import { VerticalField } from '../../../../components/Form';
import { DataModelerConfigLabelWithInfo } from '../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import { WideSingleSelectMenu } from './DataModelerDataSourceInputUI';
import { getAuthOptions } from './utils';
import React, { useMemo } from 'react';
import { IAuthTypeProps } from './AuthTypes/types';
import { BasicAuth } from './AuthTypes/BasicAuth';
import KeyPair from './AuthTypes/KeyPair';
import { AuthType } from '../../../../utils/apollo/graphqlSchema';

export const DataModelerBasicAuthenticationType = ({
  readOnly,
  canEditProps,
  basicInput,
  setBasicInput,
}: IAuthTypeProps) => {
  const { strategy, authType } = basicInput;

  const handleOnChange = (value: string) => {
    // clean up when the auth type is changed
    // the user is kept since it is shared prop
    setBasicInput({
      ...basicInput,
      authType: value as AuthType,
      password: null,
      privateKey: null,
    });
  };

  const AuthTypeRenderer = () => {
    switch (authType) {
      case AuthType.UserPassword:
        return (
          <BasicAuth
            readOnly={readOnly}
            canEditProps={canEditProps}
            basicInput={basicInput}
            setBasicInput={setBasicInput}
          />
        );
      case AuthType.UserPrivateKey:
        return (
          <KeyPair
            readOnly={readOnly}
            canEditProps={canEditProps}
            basicInput={basicInput}
            setBasicInput={setBasicInput}
          />
        );
      default:
        return null;
    }
  };
  const options = useMemo(() => getAuthOptions(strategy), [strategy]);
  return (
    <>
      {options.length > 1 && (
        <VerticalField noMargin={true}>
          <DataModelerConfigLabelWithInfo
            labelText={'Authentication Type'}
            tooltipOption={
              dataModelLabelInfoTooltipOptions.connectionAuthenticationType
            }
          />
          <WideSingleSelectMenu
            disabled={!canEditProps}
            value={authType}
            onChange={handleOnChange}
            options={options}
          />
        </VerticalField>
      )}
      {AuthTypeRenderer()}
    </>
  );
};
